import React from 'react';
import { FiGift } from 'react-icons/fi';

const FeedbackBanner = ({ onOpenQuestionnaire }) => {
  return (
    <div className="bg-gradient-to-r from-green-500 to-blue-500 text-white p-4 rounded-lg mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <FiGift className="text-2xl mr-3" />
          <div>
            <h3 className="font-semibold text-lg">Get 300 credits by providing a short feedback!</h3>
            <p className="text-sm opacity-90">Help us improve the app and earn credits</p>
          </div>
        </div>
        <button
          onClick={onOpenQuestionnaire}
          className="bg-white text-green-600 px-4 py-2 rounded font-medium hover:bg-gray-100 transition-colors"
        >
          Start Survey
        </button>
      </div>
    </div>
  );
};

export default FeedbackBanner;